<script setup lang="ts">
import { SerializedChartType } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { assemble } from '@/composables/charts/influx-charts/chart-builders/ChartFactory'
import { computed, ComputedRef, FunctionalComponent } from 'vue'

const props = defineProps<{ serialized: SerializedChartType }>()

const chartComponent: ComputedRef<FunctionalComponent> = computed(() => {
  return assemble(props.serialized)
})
</script>

<template>
  <chart-component></chart-component>
</template>

<style scoped></style>
